<script>
import request from '../services/request';
import {  mapActions } from 'vuex';

export default {
    data() {
        return {
            questions: [
                // {
                //     active: true,
                //     name: 'Lorem Ipsum is simply dummy text of the printing and typesetting industry.',
                //     description: 'Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industrys standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book. It has survived not only five centuries, but also the leap into electronic typesetting, remaining essentially unchanged. It was popularised in the 1960s with the release of Letraset sheets containing Lorem Ipsum passages, and more recently with desktop publishing software like Aldus PageMaker including versions of Lorem Ipsum.'
                // },
                // {
                //     active: false,
                //     name: 'ontrary to popular belief, Lorem Ipsum is not simply random text. ',
                //     description: 'Contrary to popular belief, Lorem Ipsum is not simply random text. It has roots in a piece of classical Latin literature from 45 BC, making it over 2000 years old. Richard McClintock, a Latin professor at Hampden-Sydney College in Virginia, looked up one of the more obscure Latin words, consectetur, from a Lorem Ipsum passage, and going through the cites of the word in classical literature, discovered the undoubtable source. Lorem Ipsum comes from sections 1.10.32 and 1.10.33 of "de Finibus Bonorum et Malorum" (The Extremes of Good and Evil) by Cicero, written in 45 BC. This book is a treatise on the theory of ethics, very popular during the Renaissance. The first line of Lorem Ipsum, "Lorem ipsum dolor sit amet..", comes from a line in section 1.10.32.'
                // }
            ]
        }
    },
    methods: {
        navItemCollapse(index) {
            console.log(index);
            this.questions = this.questions.map((item, i) => {
                item.active = !item.active
                if (i !== index) {
                    item.active = false
                }
                return item
            })
        },
        async getFaqs() {
            let vm = this;
            try {
                let _endpoint = '/faqs';
                let service = request;

                let { data } = await service.get(_endpoint)
                if (data) {
                    data.data.forEach(function (valor, indice) {
                        let faq  = {
                            'active' : indice == 0 ? true : false,
                            'name' : valor.question,
                            'description' : valor.answer,
                        };
                        vm.questions.push(faq);
                    });
                    console.log(data);
                }
            } catch (error) {
                this.errors = await this.errorNotification(error)
            }
        },
        ...mapActions({
            errorNotification: 'alert/error',
            successNotification: 'alert/success',
        }),
    },
    created() {
        this.getFaqs();
    },
}
</script>
<template>
    <div class="row">
        <div class="col-12">
            <h2>Preguntas frecuentes</h2>
            <h4 class="text-muted">Ayuda sobre el sistema</h4>
            <hr>
        </div>
        <div class="col-12">
            <div class="accordion" id="accordionExample">
                <div class="card" v-for="(question, index_question) in questions" :key="index_question">
                    <div class="card-header" :id="`heading-d${index_question}`">
                        <h5 class="mb-0">
                            <button class="btn btn-link text-muted pl-0" @click.prevent="navItemCollapse(index_question)"
                                type="button">
                                <div class="div-icon rounded-circle mr-2">
                                    <i class="fa-solid fa-question"></i>
                                </div>
                                {{ question.name }}
                            </button>
                        </h5>
                    </div>

                    <div :id="`collapsee-d${index_question}`" :class="[question.active == true ? 'show' : '', 'collapse']"
                        :aria-labelledby="`heading-d${index_question}`" data-parent="#accordionExample">
                        <div class="card-body">
                            {{ question.description }}
                        </div>
                    </div>
                </div>


            </div>
        </div>
    </div>
</template>